export const APP_VERSION = '2.0.0';
export const ENABLE_REDUX_LOGGER = false;

// Runtime config injected by public/config.js at page load (generated per-env
// at deploy time). See deployment-steps.yaml.
// eslint-disable-next-line no-underscore-dangle
const appConfig = (typeof window !== 'undefined' && window.__APP_CONFIG__) || {};

export default appConfig;
